import script from "./TicketsTableComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketsTableComponent.vue?vue&type=script&setup=true&lang=ts"

import "./TicketsTableComponent.vue?vue&type=style&index=0&id=a609e646&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a609e646"]])

export default __exports__